
export const SET_CAMERA_PARAMS = 'mapmultiscene/SET_CAMERA_PARAMS';
export const SET_MMS_POINT = 'mapmultiscene/SET_MMS_POINT';

export default function getActions(dispatch) {
    return {
        setCameraParams: (cameraParams) => dispatch({
            type: SET_CAMERA_PARAMS, cameraParams
        }),
        setMmsPoint: (mmsPoint) => dispatch({
            type: SET_MMS_POINT, mmsPoint
        })
    };
}
